export * from './ProductFavoriteButton.types';
export { default as ProductFavoriteButton } from './ProductFavoriteButton';
